module.exports = __webpack_public_path__ + "static/report/img/mw9.01ecb747.png";